<template>
  <div>
    <GmapMarker
      v-if="status !== 'RESERVED'"
      :position="position"
      :clickable="false"
      :draggable="true"
      :zIndex="3"
      @dragstart="handleDragstart"
      @dragend="handleDragend">
    </GmapMarker>
    <GmapMarker
      v-if="departure.location"
      :position="departure.location"
      :clickable="false"
      :draggable="false"
      :zIndex="2"
      :icon="departureIcon()">
    </GmapMarker>
    <GmapMarker
      v-if="arrival.location"
      :position="arrival.location"
      :clickable="false"
      :draggable="false"
      :zIndex="2"
      :icon="arrivalIcon()">
    </GmapMarker>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import polygon from '@/config/polygon'
import {gmapApi} from "vue2-google-maps";

export default {
  data () {
    return {
      position: {
        lat: 0,
        lng: 0
      },
      rendered: false,
      polygons: [],
      backup: {}
    }
  },
  created () {
    this.position = this.$store.getters['map/getCenter']
    this.render()
  },
  computed: {
    ...mapGetters({
      center: 'map/getCenter',
      departure: 'reservation/getDeparture',
      arrival:  'reservation/getArrival',
      status: 'reservation/getStatus',
      api: 'googleMap/getApi',
      map: 'googleMap/getMap'
    }),
    google: gmapApi
  },
  methods: {
    departureIcon: function () {
      let size = new this.google.maps.Size(36,36)
      return {
        url: require('@/assets/images/mapmarker/pin_taxi_from@3x.png'),
        scaledSize: size
      }
    },
    arrivalIcon: function () {
      let size = new this.google.maps.Size(36,36)
      return {
        url: require('@/assets/images/mapmarker/pin_taxi_to@3x.png'),
        scaledSize: size
      }
    },
    handleDragstart: function (e) {
      this.backup = {
        lat: e.latLng.lat(),
        lng: e.latLng.lng()
      }
    },
    handleDragend: function (e) {
      if (this.isServiceArea(e.latLng)) {
        const location = {
          lat: e.latLng.lat(),
          lng: e.latLng.lng()
        }
        this.$store.dispatch('reservation/updatePosition', location)
      } else {
        this.position = this.backup
      }
    },
    render: function () {
      if (this.api.maps && !this.rendered)  {
        this.rendered = true
        polygon.forEach((a) => {
          const polygon = new this.api.maps.Polygon({
            paths: a.paths,
            clickable: false,
            map: this.map
          })
          this.polygons.push(polygon)
        })
      }
    },
    isServiceArea: function (location) {
      return this.polygons.some((p) => {
        const f = this.api.maps.geometry.poly.containsLocation(location, p)
        if (f) return true
      })
    }
  },
  watch: {
    // NOTE: GoogleMapの初期化のタイミングが後になる場合があるのでここでもwatchしておく
    api: function () {
      this.render()
    }
  }
}
</script>
